/* User defined models */
import { DatepickerDate } from './date.model';
import { DynamicFormBase } from './dynamic-form-base.model';

export class ProSchedulerDatePicker extends DynamicFormBase<string> {

  controlType = 'datepicker';
  type: string;
  rawDate: DatepickerDate;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}
